export enum BalconyOptions {
    UNKNOWN = 0,
    HAS_ANY = 1,
}
